module.exports = __webpack_public_path__ + "img/trends_11.77cd8e45.jpg";